import AcxChip from "components/UI/AcxChip";
import { ConversationClassifier } from "services/ConversationService";
import { ApplicationFilterValuesStore } from "stores/ApplicationFilters/ApplicationFilterValuesStore";
import { getChipOptionsByClassifier, ML_SentimentV2 } from "./Helpers";
import { Box } from "@mui/material";
import React from "react";

export default function ClassifierChip(props: {
    classifier: ConversationClassifier;
    store: ApplicationFilterValuesStore;
    index: number;
    chipMaxWidth: string;
}) {
    let { classifier, store, index, chipMaxWidth } = props;

    const { color, label, icon, label2, color2 } = getChipOptionsByClassifier(
        classifier,
        store,
    );

    let chipComponent = (
        <AcxChip
            label={label}
            size="small"
            color={color as any}
            style={{ maxWidth: chipMaxWidth }}
            icon={icon}
        />
    );

    if (classifier.name === ML_SentimentV2) {
        chipComponent = (
            <>
                <AcxChip
                    label={label}
                    size="small"
                    color={color as any}
                    style={{ marginRight: 4, maxWidth: chipMaxWidth }}
                />
                <AcxChip
                    label={label2}
                    size="small"
                    color={color2 as any}
                    style={{ maxWidth: chipMaxWidth }}
                />
            </>
        );
    }

    return (
        <Box
            sx={{
                flexShrink: 1,
                overflow: "hidden",
                paddingRight: 0.5,
            }}
            key={"sorted" + index}
        >
            {chipComponent}
        </Box>
    );
}
